import { domainPrefix } from './domainPrefix';

export const OFFER_EXPIRED_URL = {
    'albelli.be': '/kortingscodes',
    'posterxxl.de': '/gutschein',
    'posterxxl.at': '/gutschein',
    'albelli.nl': '/kortingscode',
    'bonusprint.co.uk': '/discount-codes',
    'fotoknudsen.no': '/rabattkode',
    'monalbumphoto.fr': '/code-promo',
    'onskefoto.se': '/rabattkod',
    'photobox.co.uk': '/discount-codes',
    'photobox.fr': '/code-promo',
    'photobox.ie': '/discount-codes',
    'photobox.it': '/promozioni',
    'photobox.dk': '/tilbud',
    'hofmann.es': '/descuentos',
    'hofmann.pt': '/promocoes',
};

export const publicConfigurationUrl = `https://${domainPrefix}storefront-public-conf.albelli.com/`;
export const cartApiUrl = `https://${domainPrefix}api.photoconnector.net/Carts`;
